import { useEffect, useState } from "react";
import { ProgramType } from "data/programData";
import * as _ from "lodash";
import { ProgramContentType } from "data/BlockComponent";
import { setDataWithEditorKeyAndTranslationVersion } from "./useGetBlankTaskData";
import { useRecoilValue } from "recoil";
import { deviceAtom } from "recoil/deviceAtom";
import { taskListAtom } from "recoil/taskListAtom";
import useIsInappWebview from "./useIsInappWebview";
import { patientAtom } from "../recoil/patientAtom";
import { MeditationTemplate_new, MeditationType } from "../data/task/v1/5-7-T";

export default function useGetBlankMeditationRecordData({
  mrk,
  isFirst,
  isFromThoughtRecord,
  enabled = true,
}: {
  mrk?: string;
  isFirst?: boolean;
  isFromThoughtRecord?: boolean;
  enabled?: boolean;
}) {
  const taskId = "5-7-T";
  const patientState = useRecoilValue(patientAtom);

  const [data, setData] = useState<ProgramType>();
  const deviceState = useRecoilValue(deviceAtom);
  const taskListState = useRecoilValue(taskListAtom);
  const isInappWebview = useIsInappWebview();
  const isPushNotificationGranted =
    deviceState.pushNotificationStatus === "granted" || !isInappWebview;

  const isSituationUpgraded = taskListState.some(
    (element) => element.taskId === "9-4-A" && element.isDone
  );

  function ifTaskDone(taskId: string) {
    return taskListState.find(
      (element) => element.taskId === taskId && element.isDone
    );
  }

  const meditationList = [
    ...(ifTaskDone("8-8-A") ? ["grounding"] : []),
    ...(ifTaskDone("8-8-A") ? ["relaxation"] : []),
    ...(ifTaskDone("8-9-A") ? ["breath"] : []),
    ...(ifTaskDone("9-13-A") ? ["willingness"] : []),
    ...(ifTaskDone("8-2-A") ? ["routine"] : []),
  ] as MeditationType[];

  // const meditationList = [
  //   "grounding",
  //   "relaxation",
  //   "breath",
  //   "willingness",
  //   "routine",
  // ] as MeditationType[];

  const taskData: ProgramType = {
    taskId: taskId,
    content: MeditationTemplate_new(
      `${taskId}:${patientState?.patientId}`,
      meditationList,
      mrk,
      isFromThoughtRecord,
      isSituationUpgraded
    ),
  };

  useEffect(() => {
    if (enabled) {
      let rawData = _.cloneDeep(taskData);

      if (mrk && rawData) {
        (rawData.content as ProgramContentType[])[0].lines.push([
          {
            type: "temp",
            content: {
              id: `meditationRecordKey`,
              value: mrk,
            },
          },
        ]);

        setData(setDataWithEditorKeyAndTranslationVersion(rawData));
      }
    }
  }, [mrk, enabled]);

  return data;
}
